import { render, staticRenderFns } from "./ReturnDetails.vue?vue&type=template&id=f53cebaa&scoped=true"
import script from "./ReturnDetails.vue?vue&type=script&lang=js"
export * from "./ReturnDetails.vue?vue&type=script&lang=js"
import style0 from "./ReturnDetails.vue?vue&type=style&index=0&id=f53cebaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f53cebaa",
  null
  
)

export default component.exports